import PropTypes from 'prop-types'
import { useMemo } from 'react'
import classes from '../index.module.scss'
import { BackgroundPath } from './BackgroundPath'
import { BottomPath } from './BottomPath'
import { TopPath } from './TopPath'

const BOTTOM_PATH_STROKE_WIDTH = 3
const BOTTOM_PATH_RATIO = 0.5
const PIE_CHART_RATIO = 1

export const PieChartTwoPaths = ({
  width,
  height,
  pieChartRatio,
  pathSmallRatio,
  backgroundPathFill,
  backgroundPathStroke,
  backgroundPathStrokeWidth,
  backgroundPathOuterRadius,
  topPathFill,
  topPathStroke,
  topPathStrokeWidth,
  bottomPathFill,
  bottomPathStroke,
  bottomPathStrokeWidth,
  topPathText,
  bottomPathText,
  isBottomPathSmall,
}) => {
  // Get data
  const getPieChartRatio = useMemo(() => {
    if (pieChartRatio < 0) return 0
    if (pieChartRatio > 1) return 1
    return pieChartRatio
  }, [pieChartRatio])

  const getPathSmallRatio = useMemo(() => {
    if (pathSmallRatio < 0) return 0
    if (pathSmallRatio > 1) return 1
    return pathSmallRatio
  }, [pathSmallRatio])

  const getMinSize = useMemo(() => {
    return Math.min(width, height) * getPieChartRatio
  }, [width, height, getPieChartRatio])

  return (
    <div
      style={{
        width: width,
        height: height,
      }}
      className="positionRelative"
    >
      <div
        style={{
          width: getMinSize,
          height: getMinSize,
        }}
        className={classes.pieChartTwoPathsContainer}
      >
        <div className="positionRelative wh100">
          <BackgroundPath
            size={getMinSize}
            backgroundPathFill={backgroundPathFill}
            backgroundPathStroke={backgroundPathStroke}
            backgroundPathStrokeWidth={backgroundPathStrokeWidth}
          />
          <TopPath
            size={getMinSize}
            pathSmallRatio={getPathSmallRatio}
            backgroundPathOuterRadius={backgroundPathOuterRadius}
            topPathFill={topPathFill}
            topPathStroke={topPathStroke}
            topPathStrokeWidth={topPathStrokeWidth}
            topPathText={topPathText}
            isBottomPathSmall={isBottomPathSmall}
          />
          <BottomPath
            size={getMinSize}
            pathSmallRatio={getPathSmallRatio}
            backgroundPathOuterRadius={backgroundPathOuterRadius}
            bottomPathFill={bottomPathFill}
            bottomPathStroke={bottomPathStroke}
            bottomPathStrokeWidth={bottomPathStrokeWidth}
            bottomPathText={bottomPathText}
            isBottomPathSmall={isBottomPathSmall}
          />
        </div>
      </div>
    </div>
  )
}

PieChartTwoPaths.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  pieChartRatio: PropTypes.number,
  pathSmallRatio: PropTypes.number,
  backgroundPathFill: PropTypes.string,
  backgroundPathStroke: PropTypes.string,
  backgroundPathStrokeWidth: PropTypes.number,
  backgroundPathOuterRadius: PropTypes.number,
  topPathFill: PropTypes.string,
  topPathStroke: PropTypes.string,
  topPathStrokeWidth: PropTypes.number,
  bottomPathFill: PropTypes.string,
  bottomPathStroke: PropTypes.string,
  bottomPathStrokeWidth: PropTypes.number,
  topPathText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.func,
  ]),
  bottomPathText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.func,
  ]),
  isBottomPathSmall: PropTypes.bool,
}

PieChartTwoPaths.defaultProps = {
  pieChartRatio: PIE_CHART_RATIO,
  pathSmallRatio: BOTTOM_PATH_RATIO,
  backgroundPathFill: '#5c5cd6',
  backgroundPathStroke: '#5c5cd6',
  backgroundPathStrokeWidth: 0,
  backgroundPathOuterRadius: 0,
  topPathFill: '#5c5cd6',
  topPathStroke: '#fff',
  topPathStrokeWidth: 0,
  bottomPathFill: '#fff',
  bottomPathStroke: '#5c5cd6',
  bottomPathStrokeWidth: BOTTOM_PATH_STROKE_WIDTH,
  isBottomPathSmall: true,
}
